import { render, staticRenderFns } from "./PlushieInfo.vue?vue&type=template&id=7359aefb&scoped=true&"
import script from "./PlushieInfo.vue?vue&type=script&lang=ts&"
export * from "./PlushieInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PlushieInfo.vue?vue&type=style&index=0&id=7359aefb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7359aefb",
  null
  
)

export default component.exports